module.exports = __webpack_public_path__ + "img/ddedit-1.af9c0985.svg";